var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Card carousel
 * Will switch a card grid to a carousel on smaller devices, and go back to
 * grid on larger devices.
 */

import { initialiser } from '@ramenjs/utilitybelt';
import { RamenComponent } from '@ramenjs/core';
import Flickity from 'flickity';

var defaultSettings = {
  adaptiveHeight: false,
  autoPlay: false,
  cellAlign: 'center',
  disableCarouselBp: 900,
  draggable: true,
  freeScroll: false,
  pageDots: false,
  pauseAutoPlayOnHover: true,
  prevNextButtons: false,
  wrapAround: false,
  responsiveSettings: false
};

var CardCarousel = function (_RamenComponent) {
  _inherits(CardCarousel, _RamenComponent);

  function CardCarousel(config) {
    var _this2 = this;

    _classCallCheck(this, CardCarousel);

    var _this = _possibleConstructorReturn(this, (CardCarousel.__proto__ || Object.getPrototypeOf(CardCarousel)).call(this));

    _this.setFlickitySettings = function () {
      /* Set settings with responsive overrides and bug fixes -
       * There's a bug with Flickity where if the number of items visisble is equal
       * to or less than the number that are in the list of slides, it will flicker
       * if the next/previous buttons are clicked when wrapAround is true. The
       * developer advises setting this to false in these situations.
       * See: https://github.com/metafizzy/flickity/issues/809
       */

      var settingsToUse = _this.responsiveMediaQuery && window.matchMedia(_this.responsiveMediaQuery).matches ? _extends({}, defaultSettings, _this.settings, _this.responsiveSettings.options) : _extends({}, defaultSettings, _this.settings);
      var carouselItemCount = _this.itemContainer.childElementCount;
      var minItemsForWrapAround = settingsToUse.minItemsForWrapAround;
      var draggable = settingsToUse.draggable,
          prevNextButtons = settingsToUse.prevNextButtons,
          wrapAround = settingsToUse.wrapAround;


      if (minItemsForWrapAround && carouselItemCount >= minItemsForWrapAround) {
        _this.showProgressIndicator();
      } else if (minItemsForWrapAround && carouselItemCount < minItemsForWrapAround) {
        //  If all carousel items are visible then don't wrapAround and don't show navigation buttons
        wrapAround = false;
        prevNextButtons = false;
        draggable = false;
        _this.hideProgressIndicator();
      }

      _this.adjustedSettings = _extends({}, settingsToUse, {
        draggable: draggable,
        prevNextButtons: prevNextButtons,
        wrapAround: wrapAround
      });
    };

    _this.init = function () {
      if (_this.mediaQuery || _this.responsiveMediaQuery) _this.bindResize();

      // If flickity is already enabled or we match the screen size return
      if (_this.mediaQuery && (_this.flickityEnabled || !window.matchMedia(_this.mediaQuery).matches)) return;

      _this.initFlickity();
    };

    _this.initFlickity = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.setFlickitySettings();

            case 2:
              _this.flickityEnabled = true;
              _this.itemContainer.classList.add('has-carousel');

              // Initialise Flickity
              _this.flickityInstance = new Flickity(_this.itemContainer, _this.adjustedSettings);
              _this.bindEvents();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.handleChange = function () {
      _this.revalidateLazyImages();

      if (_this.hideControls && _this.nextButton) {
        _this.nextButton.style.opacity = _this.flickityInstance.selectedIndex === 1 ? '0' : '1';
        _this.nextButton.classList.add('is-hidden');
      }

      if (_this.progressIndicator) {
        _this.progressIndicator.setAttribute('style', 'width: ' + _this.flickityInstance.selectedIndex / (_this.flickityInstance.slides.length - 1) * 100 + '%');
      }
    };

    _this.bindEvents = function () {
      _this.flickityInstance.on('change', _this.handleChange);
      if (_this.nextButton) _this.nextButton.addEventListener('click', function () {
        return _this.flickityInstance.next();
      });
      if (_this.previousButton) _this.previousButton.addEventListener('click', function () {
        return _this.flickityInstance.previous();
      });
    };

    _this.unBindEvents = function () {
      if (_this.nextButton) _this.nextButton.removeEventListener('click', function () {
        return _this.flickityInstance.next();
      });
      if (_this.previousButton) _this.previousButton.removeEventListener('click', function () {
        return _this.flickityInstance.previous();
      });
    };

    _this.destroyFlickity = function () {
      _this.flickityInstance.destroy();
      _this.flickityEnabled = false;
      _this.itemContainer.classList.remove('has-carousel');
      _this.unBindEvents();
    };

    _this.hideProgressIndicator = function () {
      _this.progressIndicator.parentElement.classList.add('u-hide');
    };

    _this.showProgressIndicator = function () {
      _this.progressIndicator.parentElement.classList.remove('u-hide');
    };

    _this.onResize = function () {
      if (_this.flickityEnabled && _this.mediaQuery && !window.matchMedia(_this.mediaQuery).matches) {
        _this.destroyFlickity();
        return;
      }

      if (!_this.flickityEnabled && _this.mediaQuery && window.matchMedia(_this.mediaQuery).matches) {
        _this.initFlickity();
      }

      // If flickity is already enabled and we match the responsive screen initialize flickity with responsive options
      if (_this.flickityEnabled && _this.responsiveMediaQuery && window.matchMedia(_this.responsiveMediaQuery).matches) {
        _this.destroyFlickity();
        _this.initFlickity();
      }

      // If flickity is already enabled and we do not match the responsive screen initialize flickity without responsive options
      if (_this.flickityEnabled && _this.responsiveMediaQuery && !window.matchMedia(_this.responsiveMediaQuery).matches) {
        _this.destroyFlickity();
        _this.initFlickity();
      }
    };

    var el = config.el,
        settings = config.settings;

    var disableCarouselBp = settings.disableCarouselBp,
        responsiveSettings = settings.responsiveSettings,
        nextButton = settings.nextButton,
        previousButton = settings.previousButton,
        itemContainer = settings.itemContainer,
        progressIndicator = settings.progressIndicator,
        revalidateLazyImages = settings.revalidateLazyImages,
        hideControls = settings.hideControls,
        settingsWithoutSelectors = _objectWithoutProperties(settings, ['disableCarouselBp', 'responsiveSettings', 'nextButton', 'previousButton', 'itemContainer', 'progressIndicator', 'revalidateLazyImages', 'hideControls']);

    // Set module dom elements


    _this.container = el;
    _this.itemContainer = itemContainer ? el.querySelector(itemContainer) : el;
    _this.nextButton = el.querySelector(nextButton);
    _this.previousButton = el.querySelector(previousButton);
    _this.progressIndicator = el.querySelector(progressIndicator);
    _this.mediaQuery = disableCarouselBp && '(max-width: ' + disableCarouselBp + ')';
    _this.responsiveMediaQuery = responsiveSettings ? responsiveSettings.mediaQuery : null;
    _this.revalidateLazyImages = revalidateLazyImages;
    _this.flickityEnabled = false;
    _this.flickityInstance = null;
    _this.hideControls = hideControls;
    _this.responsiveSettings = responsiveSettings;
    _this.settings = _extends({}, defaultSettings, settingsWithoutSelectors);

    _this.setFlickitySettings();
    return _this;
  }

  return CardCarousel;
}(RamenComponent);

export default (function (settings) {
  return initialiser(settings, CardCarousel);
});